module.exports = __webpack_public_path__ + "img/clients-say-logo.730ae3f8.png";